import React from 'react'
import Box from "../../components/box/Box";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Helmet} from "react-helmet";
import LazyImage from "../../components/image/LazyImage";
import {getBahabinText} from "../../util/DominantUtil";

function getImage(path, alt) {
    return <div className="col-md bordered-radius">
        <LazyImage
            src={path}
            alt={alt}
        />
    </div>;
}

export default function About() {
    const t = 'دانلود برنامه همراه';
    return (
        <Box rwFreeHeight={true} disableHeader={true} loaded={true} leftBoxClassName={'w-100 bg-white'}
             linksMap={{
                 'last': 'دانلود',
             }}
             disableAdBox={true}
             height={'h-100'}>

            <Helmet
                title={t + getBahabinText()}
                meta={[{name: 'description', content: t}, {
                    property: 'twitter:description',
                    content: "دانلود برنامه موبایل ایفون و اندروید - قیمت لحظه‌ ای، تحلیل بازار های مالی"
                }, {property: 'og:title', content: t}]}
            />
            <div className="text-center bx-ctn">
                <h1 className='p-4'>از طراحی اختصاصی نسخه موبایل لذت ببرید...</h1>
                <div className="row dl-box">
                    <a className="col-md-2 py-3" href="https://m.bahabin.com">
                        <div className="row">
                            <div className="col-4 pr-5 text-dark"><FontAwesomeIcon icon='apple-alt' size='2x'/></div>
                            <div className="col-8 dl-text"><span>نسخه آنلاین</span><br/><strong>آیفون</strong></div>
                        </div>
                    </a>
                    <a className="col-md-2 py-3" href="https://play.google.com/store/apps/details?id=com.bahabin.app">
                        <div className="row">
                            <div className="col-4 pr-5 text-dark"><FontAwesomeIcon icon='play' size='2x'/></div>
                            <div className="col-8 dl-text"><span>دانلود از</span><br/><strong>فروشگاه گوگل</strong>
                            </div>
                        </div>
                    </a>
                    <a className="col-md-2 py-3" href="https://cafebazaar.ir/app/com.bahabin.app">
                        <div className="row">
                            <div className="col-4 pr-5 text-dark"><FontAwesomeIcon icon='shopping-basket' size='2x'/>
                            </div>
                            <div className="col-8 dl-text"><span>دانلود از</span><br/><strong>کافه بازار</strong></div>
                        </div>
                    </a>
                    <a className="col-md-2 py-3" href="https://myket.ir/app/com.bahabin.app">
                        <div className="row">
                            <div className="col-4 pr-5 text-dark"><b style={{fontSize: '30px', lineHeight: '1.1'}}
                                                                     className=''>M</b></div>
                            <div className="col-8 dl-text"><span>دانلود از</span><br/><strong>مایکت </strong></div>
                        </div>
                    </a>
                    <a className="col-md-2 py-3" href="https://m.bahabin.com">
                        <div className="row">
                            <div className="col-4 pr-5 text-dark"><FontAwesomeIcon icon='atlas' size='2x'/></div>
                            <div className="col-8 dl-text"><span>نسخه آنلاین PWA</span><br/><strong>موبایل در
                                مرورگر</strong></div>
                        </div>
                    </a>
                </div>
                <div className="row dl-images pr-4 pl-4">
                    {getImage('/images/download/1.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/2.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/3.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/4.png?v5', 'نسخه موبایل بهابین')}
                </div>
                <div className="row dl-images pr-4 pl-4">
                    {getImage('/images/download/5.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/6.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/7.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/8.png?v5', 'نسخه موبایل بهابین')}
                </div>
                <div className="row dl-images pr-4 pl-4">
                    {getImage('/images/download/9.png?v5', 'نسخه موبایل بهابین')}
                    {getImage('/images/download/10.png?v5', 'نسخه موبایل بهابین')}
                </div>
            </div>
        </Box>
    )
}
